'use strict';
import { app } from '../../../bootstrap/core';
import FaqService from './faq.service'; 

import faqComponent from './faq.component';

app.component('faqComponent', faqComponent);
app.service('faqService', FaqService);
